import React from 'react';

// @atlaskit
import { AkGlobalItem } from '@atlaskit/navigation';
import Avatar from '@atlaskit/avatar';
import DropdownMenu, { DropdownItemGroup, DropdownItem } from '@atlaskit/dropdown-menu';
import Tooltip from '@atlaskit/tooltip';

// @source
import { User } from '../../../tools';

const AccountDropdownMenu = () => {
  const account = User.getUserInfo();
  const groups = [
    {
      title: `${account.Name} ${account.Surname}`,
      items: [
        // ['/#1', 'View profile'],
        // ['/#2', 'Account Settings'],
        ['/account/logout', 'Log out'],
      ],
    },
  ];
  return (
    <DropdownMenu
      appearance="tall"
      position="right bottom"
      trigger={(
        <Tooltip content="Profile" position="right">
          <AkGlobalItem>
            <Avatar size="small" />
          </AkGlobalItem>
        </Tooltip>
      )}
    >
      {groups.map(({ title, items }) => (
        <DropdownItemGroup key={title} title={title}>
          {items.map(([url, text, Icon]) => (
            <DropdownItem key={url} href={url} elemBefore={Icon}>{text}</DropdownItem>
          ))}
        </DropdownItemGroup>
      ))}
    </DropdownMenu>
  );
};

export default AccountDropdownMenu;
